import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import image from "../../assets/a.png";
import image2 from "../../assets/b.png";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Education"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src={image}
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">
								Master of Science in Information Technology
							</div>
							<div className="work-subtitle">
								Atlantis University Miami
							</div>
							<div className="work-duration">2017 - 2019</div>
						</div>

						<div className="work">
							<img
								src={image2}
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">
								Mecatronic Engineering Degree
							</div>
							<div className="work-subtitle">
								UIDE - Universidad Internacional del Ecuador
							</div>
							<div className="work-duration">2009 - 2015</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
